import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Select, Space, Card } from "antd";
import PageMeta from "~/components/common/meta";
import { BillingSubNav } from "~/components/admin/billing";
import { InvoiceCreation } from "~/components/admin/billing/invoice-creation";
import { BookingListForInvoice } from "~/components/admin/billing";

const { Option } = Select;

const ScreenCreateInvoice: React.FC = () => {
  const { bookingId } = useParams<{ bookingId?: string }>();
  const navigate = useNavigate();

  // Filter state
  const [filters, setFilters] = useState({
    bookingStatus: "", // Default to all status
  });

  // Pagination state
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const handlePaginationChange = (page: number, pageSize?: number) => {
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize || prev.pageSize,
    }));
  };

  const handleTotalUpdate = (total: number) => {
    setPagination((prev) => ({
      ...prev,
      total,
    }));
  };

  const handleFilterChange = (key: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    // Reset to first page when filter changes
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  return (
    <div>
      <PageMeta
        title={
          bookingId
            ? "Create Invoice | Art Handler"
            : "Select Booking for Invoice | Art Handler"
        }
        description={
          bookingId
            ? "Create invoice for selected booking"
            : "Select a booking to create invoice"
        }
      />

      <BillingSubNav activeKey="invoicing" />

      {bookingId ? (
        <InvoiceCreation bookingId={bookingId} />
      ) : (
        <div>
          {/* Filters */}
          <Card className="mb-4">
            <Space>
              <span>Booking Status:</span>
              <Select
                value={filters.bookingStatus}
                onChange={(value) => handleFilterChange("bookingStatus", value)}
                style={{ width: 200 }}
              >
                <Option value="">All Status</Option>
                <Option value="COMPLETED">Completed</Option>
                <Option value="IN_PROGRESS">In Progress</Option>
                <Option value="PENDING">Pending</Option>
                <Option value="CANCELLED">Cancelled</Option>
              </Select>
            </Space>
          </Card>

          {/* Booking List */}
          <BookingListForInvoice
            filters={filters}
            pagination={pagination}
            onPaginationChange={handlePaginationChange}
            onTotalUpdate={handleTotalUpdate}
            onBackToInvoiceList={() => {
              sessionStorage.setItem("fromCreateInvoice", "true");
              navigate("/billing/invoicing");
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ScreenCreateInvoice;
